<template>
  <section id="e2v">
    <div class="wrap">
      <div class="e2a-grid">
        <div>
          <h2 class="h2">Automate content with e2v</h2>
          <p class="lede" style="margin-top:14px">Connect your CRM, DMS or POS. When a record sells or expires, it leaves every screen. Nobody logs in.</p>
          <div class="e2a-chips" role="tablist" aria-label="Choose an industry">
            <button class="e2a-chip on" type="button" data-s="re"><i></i>Real estate listings</button>
            <button class="e2a-chip" type="button" data-s="car"><i></i>Dealer stock</button>
            <button class="e2a-chip" type="button" data-s="ret"><i></i>Retail specials</button>
          </div>
        </div>
        <div class="e2a-stage" id="e2aStage">
          <div class="e2a-screen"><div class="e2a-wrap" id="e2aWrap"></div></div>
          <div class="e2a-rec"><div><small id="e2aName"></small><strong id="e2aState"></strong></div><span class="e2a-pill live" id="e2aPill"></span><button type="button" class="e2a-btn" id="e2aBtn"></button></div>
          <p class="e2a-hint" id="e2aHint" hidden></p>
        </div>
      </div>
    </div>
  </section>
</template>

<script> 
// Extracted from the published landing page; in-page anchors emit instead of
// navigating, because the app uses a hash router.
export default { name: "E2vSection" };
</script>
